<template>
  <div class="">
    <p>نوع محصول</p>
    <select @change="productTypeFilter" v-model="productType" class="custom-select">
      <option value="">نمایش همه</option>
      <option value="0">فیزیکی</option>
      <option value="1">دیجیتال</option>
    </select>
  </div>
</template>

<script>
export default {
  name: "ProductType",
  data() {
    return {
      productType: '',
    }
  },
  methods: {
    productTypeFilter() {
      this.$store.commit("Product/setFilters", {key: "is_digital", value: this.productType});
      this.$emit('updateFilter', {is_digital: this.productType})
      this.$store.dispatch('Product/setDashboardProducts', 1)
    }
  },
  mounted() {
    const value = this.$route.query.is_digital;
    if (value != undefined) {
      this.$store.commit('Product/setFilters', {key: 'is_digital', value: value})
    }
  },
  destroyed() {
    this.$store.commit("Product/setFilters", {key: "is_digital", value: ''});
  }
}
</script>

<style scoped>

</style>